import { PaymentOption } from '@/modules/checkout/_core/domain/entities'
import { linkContainer, linkRegistry } from '@/modules/checkout/_core/inversify'
import { PaymentLinkByIdService } from '@/modules/checkout/_core/services/payment-link-by-id'
import { getFingerprint } from '@/shared/utils/fingerprint'
import { getRecaptchaToken } from '@/shared/utils/recaptcha'

export type PayGenerateOption =
  | PaymentOption.Pix
  | PaymentOption.AutomaticPixCopyPaste
  | PaymentOption.BankSlip

type PaymentLinkByIdProps = {
  id: string
  type: PayGenerateOption
  paymentType: number
}

export async function payLinkById({
  id,
  type,
  paymentType,
}: PaymentLinkByIdProps) {
  const { token: recaptchaToken } = await getRecaptchaToken('PAY')

  const service = linkContainer.get<PaymentLinkByIdService>(
    linkRegistry.PaymentLinkByIdService,
  )

  const { visitorId } = await getFingerprint()

  const { data: response, error } = await service.execute(id, {
    payment_type: paymentType,
    recaptcha_token: recaptchaToken,
    mkt_gtm: visitorId,
  })

  if (error) {
    throw typeof error === 'string' ? JSON.parse(error) : error
  }

  if (
    type === PaymentOption.BankSlip &&
    (!response || !response.bankslip?.barcode || !response.bankslip?.expDate)
  ) {
    throw new Error('Não foi possível gerar o boleto')
  }

  const isPix =
    type === PaymentOption.Pix || type === PaymentOption.AutomaticPixCopyPaste

  if (isPix && (!response || !response.pix?.qrCode)) {
    throw new Error('Não foi possível gerar o QR Code')
  }

  return response
}
